import dayjs from "dayjs"

export const clientEngagementScoresTransformer = (response, queryArgs) => {
  const payload = response?.data ?? {}
  const reportingRows = payload.scores ?? []
  const windowStart = payload.startDate ?? queryArgs?.startDate ?? null
  const windowEnd = payload.endDate ?? queryArgs?.endDate ?? null

  const observationsByReportingDay = new Map()
  ;[...reportingRows]
    .sort((a, b) => dayjs(a?.date).valueOf() - dayjs(b?.date).valueOf())
    .forEach(entry => {
      observationsByReportingDay.set(dayjs(entry?.date).format("YYYY-MM-DD"), {
        score: entry?.score || 0,
        segmentId: entry?.segmentId,
        staffName: entry?.staffName,
        percentageChange: entry?.percentageChange,
      })
    })

  const trendDailyPoints = []
  if (windowStart && windowEnd) {
    let latestObservation = null
    const rangeLastDay = dayjs(windowEnd)

    let incrementingDay = dayjs(windowStart)
    while (!incrementingDay.isAfter(rangeLastDay, "day")) {
      const yyyyMmDd = incrementingDay.format("YYYY-MM-DD")
      if (observationsByReportingDay.has(yyyyMmDd)) {
        latestObservation = observationsByReportingDay.get(yyyyMmDd)
      }

      trendDailyPoints.push({
        date: yyyyMmDd,
        dateLabel: incrementingDay.format("MMM DD"),
        score: latestObservation === null ? 0 : latestObservation?.score,
        segmentId: latestObservation?.segmentId,
        staffName: latestObservation?.staffName,
        percentageChange: latestObservation === null ? null : latestObservation?.percentageChange,
      })

      incrementingDay = incrementingDay.add(1, "day")
    }
  }

  return {
    trendDailyPoints,
    startDate: windowStart,
    endDate: windowEnd,
    totalScores: reportingRows.length,
  }
}
